import { useCallback, useRef } from 'react';
import { Flex, RootScreen } from '@banhala/ui-kit';
import {
  useSetScreenName,
  useReportTTFD,
  useGetCommonParams,
} from '../../hooks';
import { ScreensResult } from '../../components';
import { FilterListAtomicProvider } from 'shared/src/component';
import { useNativeScrollSync, useNativeScrollToTop } from 'shared/src/hooks';
import type { AtomicRendererRefCurrent } from '../../components/types';

export const FragmentScreens = () => {
  useSetScreenName();
  useReportTTFD();

  const { instanceId } = useGetCommonParams();
  const listRef = useRef<AtomicRendererRefCurrent>(null);

  const {
    onScroll: onScrollSync,
    onScrollBeginDrag: onScrollBeginDragSync,
    onScrollEndDrag: onScrollEndDragSync,
  } = useNativeScrollSync({ instanceId: instanceId ?? '' });

  useNativeScrollToTop({
    instanceId: instanceId ?? '',
    onScrollToTop: useCallback(() => {
      listRef.current?.scrollToOffset({ offset: 0, animated: true });
    }, []),
  });

  return (
    <RootScreen>
      <Flex flex={1}>
        <FilterListAtomicProvider>
          <ScreensResult
            listRef={listRef}
            onScrollY={onScrollSync}
            onBeginDrag={onScrollBeginDragSync}
            onEndDrag={onScrollEndDragSync}
          />
        </FilterListAtomicProvider>
      </Flex>
    </RootScreen>
  );
};
